import { createStyles, withStyles } from '@material-ui/core/styles';
import MuiButton from '@material-ui/core/Button';
const Button = withStyles((theme) => createStyles({
    root: {
        textTransform: 'none',
        height: 55,
        boxShadow: 'none',
        borderRadius: theme.spacing(2),
    },
    disabled: {
        opacity: 0.24,
        '&$outlinedPrimary': {
            borderColor: theme.palette.primary.main,
            color: theme.palette.primary.main,
        },
        '&$outlinedSecondary': {
            borderColor: theme.palette.error.main,
            color: theme.palette.error.main,
        },
        '&$containedPrimary': {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.common.white,
        },
        '&$containedSecondary': {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.common.white,
        },
    },
    outlinedPrimary: {},
    outlinedSecondary: {},
    containedPrimary: {},
    containedSecondary: {},
}))(MuiButton);
/**
 * The default Button component to use.
 * */
export default Button;
